import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";
const fetchUpdateStudent = (userData) => {
  return api.put(`/study-users/${userData.userId}`, userData);
};

export const useUpdateStudentQuery = () => {
  return useMutation({ mutationFn: fetchUpdateStudent });
};
